export default "__VITE_ASSET__1604d3aa__"